import i18next, { type PostProcessorModule } from 'i18next';
import { IntlMessageFormat } from 'intl-messageformat';

// ICU MessageFormat 構文 ({var, plural|select|...}) を含む値を判定する
const ICU_PATTERN = /\{[a-zA-Z_][a-zA-Z0-9_]*,\s*(plural|select|selectordinal|number|date|time)\b/;

export const icuPostProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: 'icu',
  process(value, _key, options) {
    if (typeof value !== 'string' || !ICU_PATTERN.test(value)) return value;
    try {
      return new IntlMessageFormat(value, i18next.language).format(options as Record<string, unknown>) as string;
    } catch {
      return value;
    }
  },
};
